import Vue from 'vue';
import Router from 'vue-router';
import mainPage from '@/views/mainPage';
import aboutPage from '@/views/aboutPage';
import techPage from '@/views/techPage';
import projectPage from '@/views/projectPage';
import contactPage from '@/views/contactPage';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'mainPage',
      component: mainPage,
    },
    {
      path: '/about',
      name: 'aboutPage',
      component: aboutPage,
    },
    {
      path: '/t$e',
      name: 'techPage',
      component: techPage,
    },
    {
      path: '/p$s',
      name: 'projectPage',
      component: projectPage,
    },
    {
      path: '/contact',
      name: 'contactPage',
      component: contactPage,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js